import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Group invitation'}),
    routes: [
        {
            path: '/groups/invitation/code/:invitationCode/',
            component: () => import(/* webpackChunkName: "accountPages" */ './GroupInviteRegistrationPage.vue'),
            name: 'GroupInviteRegistrationPage',
            props: true,
        },
    ]
});
